import { Image } from '@/components'
import { getTimeFromNow } from '@/utils/date-time'
import NextImage from 'next/image'
import { Avatar, Box, Card, CardContent, Typography } from '@mui/material'
import Link from '@/features/ref/components/Link'

export const CardCollection = ({ article, isLarge = false }: { article: IBlogPost; isLarge?: boolean }) => {
  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 2,
        boxShadow: 'none',
        border: 'none',
        backgroundColor: 'transparent',
        backgroundImage: 'none',
      }}
    >
      <Link href={`/blog/${article.url_key}`}>
        <Image
          src={article.image || ''}
          ratio={'4/3'}
          alt={article.name}
          sx={{
            width: '100%',
            borderRadius: 2,
            mb: isLarge ? 2 : 1.5,
            backgroundColor: 'secondary.main',
          }}
        />
      </Link>
      <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
        <Typography
          variant={'h4'}
          sx={{
            fontWeight: 700,
            mb: 1,
            lineHeight: 1.5,
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            fontSize: isLarge ? '1.25em' : '1em',
          }}
        >
          <Link href={`/blog/${article.url_key}`}>{article.name}</Link>
        </Typography>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mb: 1,
          }}
        >
          <Avatar
            sx={{
              width: 24, // 24px = 3 * 8px
              height: 24,
              bgcolor: 'secondary.main',
            }}
          >
            <Typography variant="caption" sx={{ fontWeight: 600, color: 'white' }}>
              M
            </Typography>
          </Avatar>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flex: 1 }}>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
              }}
            >
              {article.author_name}
            </Typography>
            <Box sx={{ width: 16, height: 16 }}>
              <NextImage
                sizes="32px"
                src="/assets/icons/verified.png"
                alt="verified"
                width={16}
                height={16}
              />
            </Box>
            {/* <VerifiedUser
              sx={{
                width: 16, // 16px = 2 * 8px
                height: 16,
                color: 'info.main',
              }}
            /> */}
          </Box>
          <Typography
            variant="caption"
            sx={{
              fontStyle: 'italic',
              px: 0.5,
            }}
          >
            {getTimeFromNow(article.created_at)}
          </Typography>
        </Box>

        <Typography
          variant="body1"
          sx={{
            lineHeight: 1.5,
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {article.short_description}
        </Typography>
      </CardContent>
    </Card>
  )
}
